<template lang="pug">
//- pre | {{ formData }}
form(@submit.prevent="submit")
  AppButton(:label="$t('quickpayment.subscribe')" :loading="loading" :disabled="loading || disabled || service.subscription_status || invoice.payment_state === 'paid'")

</template>

<script>
import { reactive, ref } from "@vue/reactivity";
import AppCheckbox from "@/components/Form/AppCheckbox";
import AppButton from "@/components/AppButton";
import { axiosPayment, getCheckoutUrl } from "@/utils/axiosPayment";
export default {
  components: {
    AppButton,
    AppCheckbox,
  },
  props: {
    name: String,
    invoice: [Object, null],
    service: [Object, null],
    disabled: Boolean,
  },
  setup(props) {
    const loading = ref(false);
    const pathCheckout = process.env.VUE_APP_SUBSCRIPTION_URL;
    const formData = reactive({
      currency: "mxn",
      name: props.name,
      description: props.service.plan_id[1],
      reference: props.invoice.servicio_id[1].toUpperCase(),
      id: props.service.id,
      partner_id: props.invoice.partner_id[0],
      partner_name: props.invoice.partner_id[1],
      mode: "subscription",
      unit_amount: Math.ceil(props.invoice.amount_residual.toFixed(2) * 100),
      interval: "month",
      quantity: 1,
    });

    // El API de suscripciones ahora exige el Bearer de VUE_APP_TOKEN_PAYMENT, que
    // un POST nativo del form no puede enviar: se manda por axios y se redirige a
    // la URL de Stripe que responde el backend.
    const submit = async () => {
      if (loading.value) return;
      loading.value = true;
      try {
        const body = new URLSearchParams();
        Object.entries(formData).forEach(([key, value]) => {
          body.append(key, value);
        });

        const response = await axiosPayment.post(pathCheckout, body, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });

        const url = getCheckoutUrl(response, pathCheckout);
        if (!url) {
          throw new Error("Subscription URL not found in response");
        }
        window.location.href = url;
      } catch (error) {
        console.error("Error creating subscription session:", error);
        loading.value = false;
      }
    };

    return { formData, pathCheckout, loading, submit };
  },
};
</script>

<style></style>
